import { useState } from 'react';
import logo from '../../assets/logo.png';
import './Login.css';

export default function Login({ onLogin }) {
  const [user, setUser] = useState('lathinyxdevlabs@gmail.com');
  const [pass, setPass] = useState('');
  const [err, setErr] = useState('');
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetNew, setResetNew] = useState('');
  const [resetConfirm, setResetConfirm] = useState('');
  const [resetMsg, setResetMsg] = useState('');

  const doLogin = () => {
    if (user === 'lathinyxdevlabs@gmail.com' && pass === 'arvexa2026') {
      onLogin();
    } else {
      setErr('Invalid email or password. Try: lathinyxdevlabs@gmail.com / arvexa2026');
    }
  };

  const doReset = () => {
    if (!resetEmail) { setResetMsg('Please enter email.'); return; }
    if (resetNew.length < 6) { setResetMsg('Password must be at least 6 characters.'); return; }
    if (resetNew !== resetConfirm) { setResetMsg('Passwords do not match.'); return; }
    if (resetEmail === 'lathinyxdevlabs@gmail.com') {
      setResetMsg('✅ Password reset! You can now log in.');
      setTimeout(() => setShowReset(false), 1500);
    } else {
      setResetMsg('Email not found.');
    }
  };

  return (
    <div className="login-screen">
      <div className="login-box">
        <div className="login-logo">
          <img src={logo} alt="LathiNyx DevLabs" className="login-logo-img" />
          <h1>LathiNyx <span>DevLabs</span>™</h1>
          <small>Aryan · Freelancer Command Center</small>
        </div>
        <div className="d-fg">
          <div className="d-flabel">Username / Email</div>
          <input className="d-finput" value={user} onChange={e => setUser(e.target.value)} placeholder="lathinyxdevlabs@gmail.com" />
        </div>
        <div className="d-fg">
          <div className="d-flabel">Password</div>
          <input className="d-finput" type="password" value={pass} onChange={e => setPass(e.target.value)} onKeyDown={e => e.key === 'Enter' && doLogin()} placeholder="••••••••" />
        </div>
        {err && <div className="login-err">{err}</div>}
        <button className="d-btn d-btn-primary login-btn" onClick={doLogin}>Sign In →</button>
        <div className="forgot-link">Forgot password? <span onClick={() => setShowReset(true)}>Reset here</span></div>
      </div>

      {showReset && (
        <div className="d-modal-overlay open">
          <div className="d-modal" style={{ width: 380 }}>
            <div className="d-modal-title">Reset Password <span className="d-close-btn" onClick={() => setShowReset(false)}>&times;</span></div>
            <div className="d-fg"><div className="d-flabel">Registered Email</div><input className="d-finput" value={resetEmail} onChange={e => setResetEmail(e.target.value)} placeholder="lathinyxdevlabs@gmail.com" /></div>
            <div className="d-fg"><div className="d-flabel">New Password</div><input className="d-finput" type="password" value={resetNew} onChange={e => setResetNew(e.target.value)} /></div>
            <div className="d-fg"><div className="d-flabel">Confirm Password</div><input className="d-finput" type="password" value={resetConfirm} onChange={e => setResetConfirm(e.target.value)} /></div>
            {resetMsg && <div style={{ fontSize: 12, marginBottom: 8, color: resetMsg.includes('✅') ? '#4ecba0' : '#ff7c90' }}>{resetMsg}</div>}
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="d-btn" style={{ flex: 1 }} onClick={() => setShowReset(false)}>Cancel</button>
              <button className="d-btn d-btn-primary" style={{ flex: 1 }} onClick={doReset}>Reset Password</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
